//ts
import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router } from '@angular/router';
import { NavigationEnd } from '@angular/router';
// import { FavouriteLeaguePopupComponent } from 'src/app/providers/popup/user-popup/favourite-league-popup/favourite-league-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
// import { clearInterval } from 'timers';
import moment from "moment-timezone";
import { ChangeDetectorRef } from '@angular/core';
import { AfterViewChecked } from '@angular/core';
import { APIService } from '../providers/api.service';
import { UserIdleService } from 'angular-user-idle';
import { AnalyticsManagerService } from '../providers/analytics-manager.service';

@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.css'],
  providers: [ToastrService]

})
export class UserDashboardComponent implements OnInit, AfterViewChecked {

  currentYear: any;
  token: any;
  email: any;
  organizationId: any;
  userId: any;
  userName: any;
  name: any;
  lobbyCoin: any;
  gameTypeListData: any;
  passwordRequired: boolean = false;
  passwordError: boolean = false;
  rePasswordRequired: boolean = false;
  rePasswordError: boolean = false;
  oldPasswordError: boolean = false;
  previousState: any;
  menus: any;
  fromState: any;
  gameTypeList: any;
  history = [];
  loader: boolean = false
  end: any;
  now: any;
  responsiveId: any;
  userInfo: any;
  spinPerDayCompleted: boolean = false
  duration = moment.duration(10, 'seconds');
  loading: any;
  orgid: any;
  formDetail: any;
  backgroundImage: any;
  logo: any;
  public footers = [
    { 'title': 'About', 'description': 'About Description', 'path': 'about' },
    { 'title': 'Blog', 'description': '', 'path': '' },
    { 'title': 'FAQ', 'description': 'faq Description', 'path': 'faq' },
    { 'title': 'Rules', 'description': 'rules Description', 'path': 'rules' },
    { 'title': 'Support', 'description': 'welcomeSupport Description', 'path': 'welcomeSupport' },
    { 'title': 'Terms & Conditions', 'description': 'legal Description', 'path': 'legal' },
    { 'title': 'Privacy Policy', 'description': 'privacyPolicy Description', 'path': 'privacyPolicy' }
  ];


  constructor(public APIService: APIService, private localStorageService: LocalStorageService, public router: Router,
    public dialog: MatDialog, private toastr: ToastrService, private cdRef: ChangeDetectorRef, private MatDialog: MatDialog, private userIdle: UserIdleService, public analyticsManager: AnalyticsManagerService) {

    this.currentYear = new Date().getFullYear();

    if (localStorage.getItem('email') && localStorage.getItem('token') && localStorage.getItem('organizationId')) {
      this.localStorageService.set('email', localStorage.getItem('email'));
      this.localStorageService.set('token', localStorage.getItem('token'));
      this.localStorageService.set('organizationId', localStorage.getItem('organizationId'));
      localStorage.removeItem('email')
      localStorage.removeItem('token')
      localStorage.removeItem('organizationId')
    }

    this.email = this.localStorageService.get('email');
    this.localStorageService.get(this.email);
    this.token = this.localStorageService.get('token');
    this.organizationId = this.localStorageService.get('organizationId');

    if ((this.email == undefined || this.email == null) && (this.token == "" || this.token == null)) {
      this.router.navigate(['/welcome/playnow/']);
    }
  }

  getExactURL = function (url) {
    var the_arr = url.split('/');
    if (the_arr.length > 3) {
      the_arr.pop();
      return (the_arr.join('/'));
    } else {
      return url
    }
  }

  ngOnInit() {
    this.orgid = this.localStorageService.get('organizationId');
    // console.log(this.orgid)
    this.getAdminDetails();
    //Start watching for user inactivity.
    this.userIdle.startWatching();

    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe(count => {
    });

    // Start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => {
      this.MatDialog.closeAll();
      this.logout();
    });


    var self = this;
    // self.selectingTab(self.menus[0]);

    if (localStorage.getItem('email') && localStorage.getItem('token')) {
      self.localStorageService.set('email', localStorage.getItem('email'));
      self.localStorageService.set('token', localStorage.getItem('token'));
      localStorage.removeItem('email')
      localStorage.removeItem('token')
    }
    self.email = self.localStorageService.get('email');
    self.userId = self.localStorageService.get('userId');
    self.userName = self.localStorageService.get('userName');
    this.localStorageService.add('userName', self.userName);
    self.token = self.localStorageService.get('token');
    self.localStorageService.remove('compaignUrl');
    localStorage.removeItem('compaignUrl');
    let urlContent = window.location.origin + '/blog';

    if (self.email == undefined && self.token == "") {
      // $state.go('welcome.playnow');
      self.router.navigate(['/welcome/playnow/'])
    }

    self.spinFunction();
    if (self.email) {
      self.loader = true;
      self.APIService.doApiCall(function (data) {
        // $timeout(function() {
        self.userName = data.Data.userName;
        self.loader = false;
        self.name = data.Data.firstName;
        self.userId = data.Data.userId;
        self.localStorageService.add('userId', self.userId);
        self.lobbyCoin = data.Data.coinBalance;
        if (data.Data.roleId === 1) {
          self.router.navigate(['/dashboard/home']);
          // window.location.href = "newadmin.html";
        }
        // },4000);
      }, 'api/profile/userinfo?email=' + self.email, 'GET', null, null);
    }


    self.gameTypeList = [];

    self.loader = true;
    self.APIService.doApiCall(function (data) {
      self.loader = false;
      self.gameTypeListData = data.Data;
      self.gameTypeList.push({
        label: 'ALL SPORTS',
        leagueId: 0
      });
      for (var i = 0; i < self.gameTypeListData.length; i++) {
        self.gameTypeList.push(self.gameTypeListData[i]);
      }
      self.responsiveId = self.gameTypeList[0].leagueId;
    }, 'api/game/type/active/orglist?organizationId='+ self.orgid, 'GET', null, null);

    self.menus = [{
      "title": "LOBBY",
      "active": null,
      "href": "/user/lobby",
      "visible": true
    }, {
      "title": "MY ACCOUNT",
      "active": null,
      "href": "/user/myAccount",
      "visible": true,
      "subMenus": [{
        "href": "/user/editProfile"
      }, {
        "href": "/user/makeStatement"
      }]
    }, {
      "title": "MY STANDINGS",
      "active": null,
      "href": "/user/Standings",
      "visible": true
    }, {
      "title": "LEADERBOARD",
      "active": null,
      "href": "/user/communityLeader",
      "visible": true
    }
    // ,
    // {
    //   "title": "REWARDS",
    //   "active": null,
    //   "href": "/user/shop-detail",
    //   "visible": true
    // },
    // {
    //   "title": "GET COINS",
    //   "active": null,
    //   "href": "/user/get-coins",
    //   "visible": true,
    //   "subMenus": [{
    //     "href": "/user/coinsEarned"
    //   }]
    // },
    // {
    //   "title": "Refer a Friend",
    //   "active": null,
    //   "href": "/user/refer-a-friend",
    //   "visible": true
    // }
  ]

    if (this.orgid != 1) {
      self.menus = [{
        "title": "LOBBY",
        "active": null,
        "href": "/user/lobby",
        "visible": true
      }, {
        "title": "MY ACCOUNT",
        "active": null,
        "href": "/user/myAccount",
        "visible": true,
        "subMenus": [{
          "href": "/user/editProfile"
        }, {
          "href": "/user/makeStatement"
        }]
      }, {
        "title": "MY STANDINGS",
        "active": null,
        "href": "/user/Standings",
        "visible": true
      },
      {
        "title": "LEADERBOARD",
        "active": null,
        "href": "/user/communityLeader",
        "visible": true
      }]
    }
    var url = window.location.hash.replace("#", "");
    self.selectingTab(self.menus.filter((val) => {
      return val.href == url
    })[0]);
    self.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {

        var pageViewEvent = {
          page: self.getExactURL(val.url)
        }
        let ctappage = self.getExactURL(val.url);
        // ctappage = ctappage.substring(ctappage.lastIndexOf("/")+1,ctappage.length);

        self.analyticsManager.logEvent("View Page", pageViewEvent)
        $('html, body').animate({
          scrollTop: 0
        }, 200);
        self.history.push(val.url)
        // self.previousState = self.fromState;
        for (var i = self.menus.length - 1; i >= 0; i--) {
          if (self.menus[i].href === val.url) {
            self.selectingTab(self.menus[i]);
            break;
          } else {
            if (self.menus[i].subMenus) {
              for (var j = self.menus[i].subMenus.length - 1; j >= 0; j--) {
                if (self.menus[i].subMenus[j].href === val.urlAfterRedirects) {
                  self.selectingTab(self.menus[i]);
                  break;
                };
              }
            }
          }
        }
      }
    }
    )

  }


  logout = function () {
    var self = this;
    self.analyticsManager.logEvent("Logout");
    self.analyticsManager.setUserId(null);
    if (self.localStorageService.get("KeepMeloggedIn") == true) {
      self.localStorageService.add("userName", self.userName);
      self.localStorageService.remove("KeepMeloggedIn");
    }
    self.APIService.doApiCall(function (data) {
      if (data.StatusCode == 'SG001') {
        localStorage.removeItem("isFrom");
        self.localStorageService.remove('email');
        self.localStorageService.remove('token');
        self.localStorageService.remove('role');
        self.localStorageService.remove('super_admin_name');
        self.userId = null;
        // $state.go('welcome.playnow');
        self.router.navigate(['/welcome/playnow']);
      }
    }, 'api/user/logout?accessToken=' + self.token, 'GET', null, null);
  }

  passwordValidate = function (data) {
    var self = this;
    if (data == null || data == undefined || data == '') {
      self.passwordRequired = true;
      self.passwordError = false;
    } else {
      self.passwordRequired = false;
      if (data.match(/^(?=.*[0-9])(?=.*["*()+@&#$%^!<>?_-])(?=.*[A-Z])[a-zA-Z0-9&#$%^!@<>?"_+-=*()]{8,20}$/)) {
        self.passwordError = false;
      } else {
        self.passwordError = true;
      }
    }
  }

  resetPasswordValidate = function (data1, data2) {
    var self = this;
    if (data1 == null || data1 == undefined || data1 == '') {
      self.rePasswordRequired = true;
      self.rePasswordError = false;
    } else {
      self.rePasswordRequired = false;
      if (data1 == data2) {
        self.rePasswordError = false;
      } else {
        self.rePasswordError = true;
      }
    }
  }

  currentPasswordValidate = function (data) {
    var self = this;
    if (data == undefined || data == null || data == '') {
      self.oldPasswordError = true;
    } else {
      self.oldPasswordError = false;
    }
  }

  resetMail = function (datam) {
    var self = this;
    // var data = angular.copy(datam);
    var data = Object.assign({}, datam);
    if (data == undefined) {
      self.oldPasswordError = true;
      self.passwordRequired = true;
      self.rePasswordRequired = true;
    } else {
      self.passwordValidate(data.password);
      self.resetPasswordValidate(data.retype, data.password);
      if (data.retype != data.password) {
        self.rePasswordError = true;
      }
      data.email = self.email;
      if (!self.passwordRequired && !self.passwordError && !self.rePasswordRequired && !self.rePasswordError && !self.oldPasswordError) {
        delete data.retype;
        self.loader = true;
        self.APIService.doApiCall(function (data) {
          self.loader = false;
          if (data.StatusCode == 'SG005') {
            self.toastr.success(data.Message);
            // $state.go('userDashboard.myAccount');
            self.router.navigate(['/user/myAccount']);
          } else {
            let errormsg = data.Message;
            setTimeout(() => {
              errormsg = "";
            }, 4000)
          }
        }, 'api/profile/resetpassword?requestedBy=' + self.userId, 'PUT', data, null);
      }
    }
  }

  // favouriteLeaguePopup = function () {
  //   var self = this;
  //   let dialogRef = self.dialog.open(FavouriteLeaguePopupComponent, {
  //     width: '900px',
  //     data: {
  //       user_Id: {
  //         userId: self.userId
  //       }
  //     }
  //   });

  //   dialogRef.afterClosed().subscribe({

  //   });

  //   // })
  //   // var favLeague = $uibModal.open({
  //   //   animation: true,
  //   //   templateUrl: 'partials/end_user/favourite-league.html',
  //   //   controller: 'favouriteLeaguePopupController',
  //   //   size: 'lg',
  //   //   resolve: {
  //   //     user_Id: function () {
  //   //       return { userId: $scope.userId }
  //   //     }
  //   //   }
  //   // });
  //   // favLeague.result.then(function () {

  //   // })
  // }

  selectingTab = function (data) {
    var self = this;
    // if (data.href != '/user/get-coins' && data.href != '/user/buyCoins' && data.href != '/user/coinsEarned') {
    //   localStorage.removeItem('isOrderPopupClicked');
    // }
    if (data) {
      self.active = data;
      var menuEvent = {
        menu: data.title
      }

      self.analyticsManager.logEvent("Interactions - Main Actions", menuEvent);
      for (var i = self.menus.length - 1; i >= 0; i--) {
        self.menus[i].active = null
      }
      self.active.active = "activeNew";
    }
  }


  loadFooterContent(footer) {
    if (footer.title !== 'Blog') {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['user', footer.path])
      );
    
      window.open(url, '_blank');
    } else {
      window.open('http://blog.statementgames.com', '_blank');
    }

  }

  spinFunction = function () {
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');

    if (script.src.match(/main-admin.js/gi)) {
      this.parentNode.removeChild(this);
    }

    script.src = "assets/js/libs/main.js";
    script.type = 'text/javascript';
    head.appendChild(script)
  }


  getAdminDetails = function () {
    var self = this;
    self.APIService.doApiCall(function (data) {
      // console.log(data)
      self.formDetail = data.Data;
      // console.log(self.orgid)
      if(self.formDetail.image != null){

        self.logo = data.Data.image

      }
      if (self.orgid != 1) {
        if (self.formDetail.backgroundImage != undefined && self.formDetail.backgroundImage != '' && self.formDetail.backgroundImage != null) {
          self.backgroundImage = self.formDetail.backgroundImage;
          // console.log(self.backgroundImage)
        }
        else {
          self.backgroundImage = 'assets/img/new-lobby.jpg';
          // console.log(self.backgroundImage)
        }
      }
      else {
        self.backgroundImage = 'assets/img/new-lobby.jpg';
      }
    }, 'api/organization/organizationinfobyId?organizationId=' + self.orgid, 'GET', null, null);
  }
  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }
}
